var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_89_3729","style":{"maskType":"luminance"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"25","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0.5H24V20.5H20V24.5H0V0.5Z","fill":"white"})),React.createElement("g",{"mask":"url(#mask0_89_3729)","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 4.49976V2.49976H6V4.49976H2V22.4998H22V4.49976H18V2.49976H16V4.49976H8ZM16 8.49976V6.49976H8V8.49976H6V6.49976H4V10.4998H20V6.49976H18V8.49976H16ZM20 12.4998H4V20.4998H20V12.4998Z","fill":"black"}))]);
}

Calendar.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
